import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
import mednalogo from "../Images/bg/mednalogo.png";
import MednaBrand from "../../config/MednaBrand";

const menuDataOne = [
  { title: 'About Us', href: '/about' },
  { title: 'Appointment', href: '/appointments' },
  { title: 'Cloud & On-Premise Options' },
  { title: '24/7 Local Support' },
  { title: 'Privacy Policy', href: '/' },
];
const menuDataTwo = [
  { title: 'Contact Us', href: '/contact' },
  { title: 'UAE 🇦🇪' },
  { title: ' ISO 27001 Certified  ' },
  { title: 'Terms and Conditions', href: '/' },
];

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color" style={{ margin: 0 }}>
      {/* <div
        className="cs_footer_logo_wrap"
        style={{ 
          backgroundImage: process.env.PUBLIC_URL + 'url(/images/footer_bg_1.svg)',
          padding: '8px 0'
        }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: process.env.PUBLIC_URL + 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            imgUrl={mednalogo}
            className="cs_footer_brand_icon" />
          <h2 className="cs_footer_brand_text">Medna Data Systems</h2>
        </div>
      </div> */}
      <div className="cs_footer_main" style={{ padding: '5px 0' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="cs_footer_item" style={{ padding: '5px 0' }}>
                <TextWidget logoUrl={mednalogo} text={MednaBrand.name} logoWidth={'50%'} />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item" style={{ padding: '5px 0' }}>
                <MenuWidget data={menuDataOne} />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item" style={{ padding: '5px 0' }}>
                <MenuWidget data={menuDataTwo} />
              </div>
            </div>
            {/* <div className="col-lg-4">
              <div className="cs_footer_item" style={{ padding: '5px 0' }}>
                <Newsletter
                  title="Be Our Subscribers"
                  subTitle="To get the latest updates on our software from our experts"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* <div className="cs_footer_bottom cs_accent_bg" style={{ padding: '8px 0' }}>
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © 2024 Pro Health. All rights reserved.
            </div>
          </div>
        </div>
      </div> */}
    </footer>
  );
}
